import React from 'react';
import { motion } from 'framer-motion';
import { ModeProps } from '../../types';
import { Button } from '../ui/Button';
import { ArrowRight, PlayCircle } from 'lucide-react';
export function Hero({
  mode
}: ModeProps) {
  const isBusiness = mode === 'business';
  const content = {
    business: {
      headline: 'One infrastructure to move money globally.',
      subtext: 'Obseq provides regulated, programmable money infrastructure for fintechs, banks, platforms, and global businesses.',
      primaryCta: 'Talk to Sales',
      secondaryCta: 'View Products'
    },
    individual: {
      headline: 'Your money. Globally accessible. Always in control.',
      subtext: 'Hold, send, spend, and earn across borders — without friction.',
      primaryCta: 'Join Waitlist',
      secondaryCta: 'How It Works'
    }
  };
  const current = isBusiness ? content.business : content.individual;
  return <section className="relative pt-32 pb-20 md:pt-48 md:pb-32 overflow-hidden" data-id="element-254">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-255">
        <div className="max-w-4xl mx-auto text-center" data-id="element-256">
          <motion.div key={`badge-${mode}`} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-slate-100 text-slate-600 text-sm font-medium mb-8" data-id="element-257">
            <span className="w-2 h-2 rounded-full bg-blue-500" data-id="element-258" />
            {isBusiness ? 'Enterprise-grade Infrastructure' : 'Now accepting early access'}
          </motion.div>

          <motion.h1 key={`headline-${mode}`} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-3xl sm:text-5xl md:text-7xl font-bold tracking-tight text-slate-900 mb-6 leading-[1.1]" data-id="element-259">
            {current.headline}
          </motion.h1>

          <motion.p key={`subtext-${mode}`} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="text-base sm:text-xl text-slate-600 mb-8 sm:mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-260">
            {current.subtext}
          </motion.p>

          <motion.div key={`cta-${mode}`} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-261">
            {isBusiness ? <a href="mailto:sales@obseq.xyz" className="w-full sm:w-auto" data-id="element-262">
                <Button size="lg" className="w-full min-w-[160px]" data-id="element-263">
                  {current.primaryCta}
                  <ArrowRight className="ml-2 w-4 h-4" data-id="element-264" />
                </Button>
              </a> : <Button size="lg" className="w-full sm:w-auto min-w-[160px]" data-id="element-265">
                {current.primaryCta}
                <ArrowRight className="ml-2 w-4 h-4" data-id="element-266" />
              </Button>}
            {isBusiness ? <a href="#products" className="w-full sm:w-auto" data-id="element-267">
                <Button variant="secondary" size="lg" className="w-full min-w-[160px]" data-id="element-268">
                  {current.secondaryCta}
                </Button>
              </a> : <Button variant="secondary" size="lg" className="w-full sm:w-auto min-w-[160px]" data-id="element-269">
                {current.secondaryCta}
                <PlayCircle className="ml-2 w-4 h-4" data-id="element-270" />
              </Button>}
          </motion.div>
        </div>
      </div>

      {/* Background Elements */}
      <div className="absolute inset-0 -z-10 overflow-hidden pointer-events-none" data-id="element-271">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[600px] bg-gradient-to-b from-slate-50 to-transparent rounded-[100%] opacity-60 blur-3xl" data-id="element-272" />
        <div className="absolute top-1/4 left-0 w-96 h-96 bg-blue-50 rounded-full blur-3xl opacity-30" data-id="element-273" />
        <div className="absolute top-1/3 right-0 w-96 h-96 bg-indigo-50 rounded-full blur-3xl opacity-30" data-id="element-274" />
      </div>
    </section>;
}